import axios from "axios";

import { ApiService } from "../../../../servicios/api.service";
import LocalStorageKeys from "../../../../data/localStorageKeys";

export class BeneficioApi {
  static endPoint = "afiliado/beneficio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static async countByAfiliadoIdAndComercioId(afiliadoId, comercioId) {
    const response = await axios.get(
      this.BasePath + afiliadoId + "/comercio/" + comercioId + "/count",
      this.Config
    );

    return response.data;
  }

  static async getListByAfiliadoIdAndComercioIdWithPagination(
    afiliadoId,
    comercioId,
    pagination
  ) {
    const response = await axios.post(
      this.BasePath + afiliadoId + "/comercio/" + comercioId,
      pagination,
      this.Config
    );

    return response.data;
  }
}
